import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: '¿Qué servicios de cirugía veterinaria ofreces en Almería?',
      answer: 'Ofrezco servicios especializados de cirugía veterinaria en Almería, Aguadulce, Roquetas de Mar, El Ejido, Adra, Nijar, Carboneras y cualquier municipio de toda la provincia. Mis especialidades incluyen traumatología y ortopedia (TPLO), cirugía oncológica, neurocirugía, cirugía torácica y abdominal, y tratamiento del síndrome braquicefálico.'
    },
    {
      question: '¿Realizas cirugías de traumatología y ortopedia en Almería?',
      answer: 'Sí, soy especialista en traumatología y ortopedia, cirugías como TPLO (Osteotomía de Nivelación de la Meseta Tibial) para el tratamiento de rotura de ligamento cruzado en perros, luxación de rótula, deformidades angulares, displasia o fracturas. Podremos realizarlas en tu centro veterinario.'
    },
    {
      question: '¿Realizas cirugías de neurocirugía?',
      answer: 'Sí, ofrezco servicios en tu centro de neurocirugía, compresiones vertebrales, slot ventral, hemilaminectomía, cauda equina, luxaciones...'
    },
    {
      question: '¿Realizas cirugía torácica y abdominal avanzada?',
      answer: 'Sí, realizo cirugías torácicas y abdominales avanzadas en tu centro veterinario. Incluye procedimientos complejos como shunt portosistémico, cirugía de diafragma, resecciones intestinales, esplenectomías, nefrectomías y otras intervenciones especializadas de tejidos blandos.'
    },
    {
      question: '¿Realizas cirugía oncológica avanzada?',
      answer: 'Sí, soy especialista en cirugía oncológica veterinaria. Realizo resecciones de tumores con márgenes oncológicos adecuados, mastectomías, amputaciones, cirugía reconstructiva post-resección y biopsias especializadas. Trabajo en coordinación con oncólogos para ofrecer el mejor tratamiento integral a cada paciente.'
    },
    {
      question: '¿Cuánta experiencia tienes como cirujano veterinario?',
      answer: 'Cuento con más de 25 años de experiencia en cirugía veterinaria especializada. He realizado casi 5000 cirugías en traumatología, oncología, neurocirugía y otras especialidades quirúrgicas (cirugía de tejidos blandos abdominal y torácica) en toda España. Fundamentalmente entre Andalucía y la Comunidad Valenciana.'
    },
    {
      question: '¿Cómo puedo solicitar una consulta de especialidad o segunda opinión para una opción quirúrgica para mi paciente?',
      answer: 'Puedes contactarme a través del formulario de contacto en esta web, por email a vetconejero@gmail.com o por teléfono al +34 600 581 975. Es importante que adjuntes todas las pruebas diagnósticas disponibles (radiografías, TC, RM, informes) para una valoración precisa del caso.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="preguntas-frecuentes" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Respuestas a las consultas más comunes sobre cirugía veterinaria especializada
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl overflow-hidden border border-gray-200 hover:border-blue-300 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-white/50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-blue-600 to-teal-600 rounded-full flex items-center justify-center">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-white text-xl transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            ¿Tienes más preguntas sobre cirugía veterinaria especializada?
          </p>
          <a
            href="#contacto"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center bg-gradient-to-r from-blue-600 to-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-teal-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line mr-2"></i>
            Contáctame Ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
